import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import error from 'assets/img/others/error.png';

const Alerts = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay
    const loadTimeout = setTimeout(() => setLoading(false), 1000);

    if (!loading && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (!loading) {
      navigate('/');
    }

    return () => clearTimeout(loadTimeout);
  }, [countdown, navigate, loading]);

  return (
    <div className="dark:bg flex w-full flex-col items-center justify-center rounded-[20px] bg-white dark:!bg-navy-900 md:py-12 lg:py-28 3xl:py-40">
      <img src={error} className="mt-4 w-[400px]" alt="Error" />
      <h1 className="mt-3 text-center text-4xl font-bold text-navy-700 dark:text-white lg:text-5xl">
        Ah, dang. We didn't find that page.
      </h1>
      <p className="mt-4 text-center text-sm font-normal text-navy-700 dark:text-white xl:mt-8 xl:text-lg">
        Maybe it’s best you start back at our home page...
        <a
          href="/"
          className="font-bold text-brand-500 hover:text-brand-500 dark:text-white dark:hover:text-white"
        >
          {' '}
          Return at home here
        </a>
      </p>
      <p className="mt-4 text-center text-sm font-normal text-navy-700 dark:text-white xl:mt-8 xl:text-lg">
        Redirecting in {countdown} seconds...
      </p>
    </div>
  );
};

export default Alerts;
